import React, { useContext } from 'react';
import { MockSubscriptionContext } from 'components/MockSubscriptionProvider';
import styles from './styles.module.scss';

/**
 * @returns {React.ReactElement}
 */
export const TestSubscriptionCtaButton = () => {
  const { isSubscriptionUserLoggedIn, handleLoginLogoutButtonClick } = useContext(MockSubscriptionContext);

  return (
    <button type="button" className={styles.mockLoginLogoutButton} onClick={handleLoginLogoutButtonClick}>
      { isSubscriptionUserLoggedIn ? 'Logout as Subscription User' : 'Login as Subscription User' }
    </button>
  );
};
